import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { HabitatProvider } from './shared/HabitatContext';
class CustomDomFactory {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    inject(module, props, target) {
        if (target) {
            const element = (React.createElement(HabitatProvider, { habitat: props }, React.createElement(module, props)));
            render(element, target);
        }
    }
    dispose(target) {
        if (target) {
            unmountComponentAtNode(target);
        }
    }
}
export default CustomDomFactory;
